export function parseFloatToFixed(currencyString) {
  let currencyParsed = Number.parseFloat(currencyString);
  if (isNaN(currencyParsed)) {
    return "";
  } else {
    return currencyParsed.toFixed(2);
  }
}
